export const formatApiResponse = (responseOrError) => {
  if (responseOrError?.status) {
    const { status, data, message } = responseOrError;

    if (status >= 200 && status < 300) {
      return {
        code: data.code ?? status,
        error: false,
        status: data.status ?? true,
        data: data.data ?? null,
        message: message ?? null,
        totalRecord: data.totalRecord ?? null
      };
    }

    return {
      error: true,
      status,
      data: data ?? null,
      message: data?.message ?? message ?? 'Request failed'
    };
  }

  if (responseOrError?.response) {
    const status = responseOrError.response.status ?? null;
    const data = responseOrError.response.data ?? null;
    const message = responseOrError.response.data?.message ?? responseOrError.message ?? 'Request failed';

    return {
      error: true,
      status,
      data,
      message
    };
  }

  if (responseOrError?.request) {
    return {
      error: true,
      status: null,
      data: null,
      message: 'No response received from server'
    };
  }

  return {
    error: true,
    status: null,
    data: null,
    message: responseOrError?.message ?? 'Unknown error'
  };
};

/**
 * Throw an Error when the API returns HTTP 2xx but the body indicates failure
 * (e.g. `{ code: 400, status: false, message: '...' }`).
 * The thrown error mimics an axios error so existing catch blocks that read
 * `err.response.data.message` or `err.message` keep working.
 */
export const assertApiSuccess = (resp, fallbackMessage = 'Request failed') => {
  const code = Number(resp?.code);
  const hasErrorCode = Number.isFinite(code) && code !== 0 && (code < 200 || code >= 300);
  if (resp?.error === true || resp?.status === false || hasErrorCode) {
    const message = resp?.message || fallbackMessage;
    const err = new Error(message);
    err.response = {
      status: Number.isFinite(code) ? code : null,
      data: { code: resp?.code, status: resp?.status, message }
    };
    throw err;
  }
  return resp;
};

export const normalizeApiResponse = (data, error, isLoading) => {
  return {
    data: data?.data ?? [],
    totalRecord: data?.totalRecord ?? 0,
    error: error,
    isLoading: isLoading
  };
};
